// Safe post-login redirect handling (#265). The public job page sends a
// logged-out visitor to `/?redirect=/dashboard/jobs/:id` so they land back on the
// posting after signing in. To avoid an open-redirect, only ever honour an
// IN-APP relative path: it must start with a single "/" (not "//host", not an
// absolute "https://…" URL, not a scheme). Anything else → null (fall back to the
// default landing).
export function safeRedirectPath(raw: string | null | undefined): string | null {
    if (!raw) return null;
    // Reject protocol-relative ("//evil.com") and anything not rooted at "/".
    if (!raw.startsWith('/') || raw.startsWith('//')) return null;
    // Reject a backslash trick some browsers normalise to "//".
    if (raw.includes('\\')) return null;
    return raw;
}
